var render = function render(_c,_vm){return _c('el-rate',{attrs:{"disabled":"","value":_vm.props.row[_vm.props.column],"colors":['#FF0000', '#f4d03e', '#008F39']}})
}
var staticRenderFns = []

export { render, staticRenderFns }